import { GithubTokenMessageListenerService } from './github-installation-message-listener.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GithubToolsInstallationRequestListener extends GithubTokenMessageListenerService {
  domain = 'github.tools.sap';
}
